import React from 'react';
import PropTypes from 'prop-types';
import {Icons} from '@learningblocks/exp-constants';
import className from './style.module.scss';

const {IncorrectRelative: CloseIcon} = Icons;

export function CloseButton(props) {
  return (
    <span className={className.closeButton} onClick={props.closeToast}>
      <CloseIcon />
    </span>
  );
}

CloseButton.propTypes = {
  /**
   * closeToast [ injected by library]
   */
  closeToast: PropTypes.func,
};

CloseButton.defaultProps = {};
